import { useQuery } from "@tanstack/react-query";
import useUserStore from "@/modules/users/store";
import { getConfiguracaoFormularioIdeias, getDefaultConfiguracaoFormularioIdeias } from "../firestore";
import { TConfiguracaoFormularioIdeias } from "../types";

/**
 * Hook para buscar configuração do formulário de ideias
 */
export function useConfiguracaoFormularioIdeias() {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresaId);

  return useQuery<TConfiguracaoFormularioIdeias>({
    queryKey: ["configuracaoFormularioIdeias", activeEmpresaId],
    queryFn: async () => {
      if (!activeEmpresaId) {
        return getDefaultConfiguracaoFormularioIdeias();
      }

      const configuracao = await getConfiguracaoFormularioIdeias(activeEmpresaId);
      return configuracao || getDefaultConfiguracaoFormularioIdeias();
    },
    enabled: !!activeEmpresaId,
    staleTime: 5 * 60 * 1000
  });
}
